import { render, staticRenderFns } from "./Relation_Patient_Doctor.vue?vue&type=template&id=54c2a8c8"
import script from "./Relation_Patient_Doctor.vue?vue&type=script&lang=js"
export * from "./Relation_Patient_Doctor.vue?vue&type=script&lang=js"
import style0 from "./Relation_Patient_Doctor.vue?vue&type=style&index=0&id=54c2a8c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports